import React from "react";
import { Container, Row, Col, Card, Carousel,Image, Button } from "react-bootstrap";

import "../Styles/FeaturesStyle.css";


import fe1 from "../Assets/fr1.png"
import fe2 from "../Assets/fr2.png"
import fe3 from "../Assets/fr3.png"

import series2 from "../Assets/series2.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {

  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import Featurevideos from "./Featurevideos";

const Features = () => {
  const phoneNumber = "9647505398000";
  return (
    <div id="features" className="py-5" style={{width:"100%",height:"100%"}}>
    
      <Row className="justify-content-center">
          <Col lg={8}>
          <a
      href={`https://wa.me/${phoneNumber}`}// Replace with your WhatsApp number
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-icon"
    >
  <FontAwesomeIcon icon={faWhatsapp} style={{width:30,height:30}} />
    </a>
 
           
          </Col>
        </Row>
        <Container>
        <Row>
          <Featurevideos/>
        </Row>
        </Container>
       
        <Row className="firstPage" lg={12}>
       
        {/* <img src={sc1} style={{width:"100%",height:"100%",color:"blue"}}/> */}
        
        {/* <img src={sc2} style={{width:"100%",height:"100%",color:"blue",marginTop:"20px"}}/>
        <img src={sc3} style={{width:"100%",height:"100%",color:"blue",marginTop:"20px"}}/>
        <img src={sc4} style={{width:"100%",height:"100%",color:"blue",marginTop:"20px"}}/> */}
        <img src={fe1} style={{width:"100%",height:"100%",color:"blue"}}/>
        <img src={fe2} style={{width:"100%",height:"100%",color:"blue"}}/>
        <img src={fe3} style={{width:"100%",height:"100%",color:"blue"}}/>
        </Row>
  
        <br/>
        <br/>
        <div className="container" >
      <Row className="mb-5">
        <div className="col-lg-6 col-md-12 mb-4">
          <Card style={{ backgroundColor: "#151B54" }}>
            <div className="d-flex justify-content-center align-items-center" style={{ width: "100%" }}>
              <h2 className="text-center text-white mt-3" style={{width:"90%"}}>Available Colors : Series 2025</h2>
            </div>
             <Card.Body>
             
                
              
                  <hr style={{ color: "#fff" }} />
                  <img
                    className="d-block mx-auto"
                    src={series2}
                    alt="Second slide"
                    style={{ maxWidth: "300px", maxHeight: "500px", width: "100%", height: "auto" }}
                  />
         
            
            </Card.Body>
             
          </Card>
     
        </div>

        
           <div className="col-lg-6 col-md-12 mb-4">
              <Card style={{ width: "90%", marginBottom: "20px" }}>
                <Card.Img
                  variant="top"
                
                  src={`https://img.youtube.com/vi/${"BX2FJGyIVGs"}/0.jpg`}
              
                />
                <Card.Body>
                   <Card.Title>Epilyum Laser Device Showcase</Card.Title>
                    <Card.Text>
Discover the advanced features and sleek design of our latest Epilyum laser hair removal devices. See how our innovative technology delivers professional results with unmatched precision and comfort. </Card.Text>
                    <Button style={{backgroundColor:"#151B54",borderColor:"transparent"}} href={"https://www.youtube.com/watch?v=BX2FJGyIVGs"} target="_blank">
                      Watch Video
                    </Button>
                </Card.Body>
              </Card>
            </div>
      </Row>
    </div>
       
       
 
    </div>
  );
};

export default Features;
